/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationPeekInvitationPathParams,
	OrganisationPeekInvitationResponse,
} from '../types/OrganisationPeekInvitation'

/**
 * GET /organisations/invitations/:token/peek
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::peekInvitation
 */
export async function organisationPeekInvitation(
	token: OrganisationPeekInvitationPathParams['token'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationPeekInvitationResponse>> {
	return axiosInstance.get(`/organisations/invitations/${token}/peek`, config)
}
